import { Col, Divider, Layout, Row, Space, Typography } from 'antd';
import { FacebookOutlined, LinkedinOutlined, TwitterOutlined, YoutubeOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';
import './Footer.scss';

const { Link } = Typography;

export const Footer = () => {
  return (
    <Layout.Footer className="footer">
      <div className="footer-content">
        <Row justify="space-between" align="middle">
          <Col>
            <Link href="https://npifinancial.com/" target="_blank" className="logo logo-white">
              &nbsp;
            </Link>
          </Col>
          <Col>
            <Space size="large">
              <Link href="https://npifinancial.com/" target={'_blank'}>
                Home
              </Link>
              <Link href="https://npifinancial.com/it-sourcing-services/" target="_blank">
                Services
              </Link>
              <Link href="https://npifinancial.com/about/" target="_blank">
                About
              </Link>
              <Link href="https://npifinancial.com/it-procurement-resources/" target="_blank">
                Resources
              </Link>
              <Link href="https://npifinancial.com/blog/" target="_blank">
                Blog
              </Link>
              <Link href="https://npifinancial.com/contact-us/" target="_blank">
                Contact Us
              </Link>
            </Space>
          </Col>
        </Row>
        <Divider />

        <div className="footer-disclaimer">
          <Row justify="space-between">
            <Col className="text-left">
              3340 Peachtree Road NE, Suite 1280
              <br />
              Atlanta, GA 30326
              <br />
              (404) 591-7500
            </Col>
            <Col className="text-right">
              <div>
                <Space size="middle">
                  <Link href="https://www.linkedin.com/company/npi" target="_blank">
                    {<LinkedinOutlined className="social-links" />}
                  </Link>
                  <Link href="https://twitter.com/NPI_Spend_Mgmt" target="_blank">
                    {<TwitterOutlined className="social-links" />}
                  </Link>
                  <Link href="https://www.facebook.com/NPI.SmartSpend" target="_blank">
                    {<FacebookOutlined className="social-links" />}
                  </Link>
                  <Link href="https://www.youtube.com/user/npifinancial" target="_blank">
                    {<YoutubeOutlined className="social-links" />}
                  </Link>
                </Space>
              </div>
              <div>
                <span>&copy; {moment().format('YYYY')} NPI, LLC</span>
                <Divider type="vertical" />
                <Link href="https://npifinancial.com/privacy-policy/" target="_blank">
                  Privacy Policy
                </Link>
                <Divider type="vertical" />
                <Link href="https://npifinancial.com/terms-of-use/" target="_blank">
                  Terms of Use
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Layout.Footer>
  );
};
